import { DictionariesEnum } from 'app/shared/enums';
import { personalDataDictionary } from './personalDataDictionary';
import { paymentMethodDictionary } from './paymentMethodDictionary';

export const localDictionaries = {
  [DictionariesEnum.PersonalData]: personalDataDictionary,
  [DictionariesEnum.PaymentMethod]: paymentMethodDictionary,
};
